import { Component, signal, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { I18nService } from '@itavan/lib/core/services';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App {
  private i18n = inject(I18nService);
  protected readonly title = signal('ecoseternos-web');
}
